import { useMutation } from "@apollo/client";
import { CONTACT_US } from "../../Pregrine/DiscoverOurServices/discoverOurServices.gql";
import * as Yup from "yup";
import { Field, Formik, Form } from "formik";
import { useToasts } from "react-toast-notifications";
import classes from "./EnquiryForm.module.css";
import ReCAPTCHA from "react-google-recaptcha";
import { useSelector } from "react-redux";
import { useRef } from "react";
import classNames from "classnames";
import closeIcon from "../../assets/images/closeIcon.svg";
import { useLocation } from "react-router-dom";
import UAParser from "ua-parser-js";
import { Offcanvas } from "bootstrap";

const feedBackSchema = Yup.object().shape({
  name: Yup.string()
    .trim()
    .matches(/^[A-Za-z]+(?:[-\s][A-Za-z]+)*$/, "Only alphabets allowed")
    .max(50, "Name exceeds the maximum character limit of 50")
    .required("Name is required"),
  email: Yup.string()
    .email("Invalid email")
    .matches(
      /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]{2,10})+$/,
      "Invalid email format"
    )
    .required("Email is required"),
  phone: Yup.string()
    .matches(/^[6-9]\d{9}$/, "Phone number is not valid")
    .required("Mobile is required"),
  pincode: Yup.string()
    .matches(/^\d{6}$/, "Pincode must be a 6-digit number")
    .required("Pincode is required"),
  message: Yup.string(),
  captcha: Yup.string().required("This is required"),
  formType: Yup.string(),
  terms: Yup.boolean()
    .oneOf([true], "Please agree to the terms and conditions")
    .required("Please agree to the terms and conditions"),
});

const EnquiryForm = ({ setShowEnquireFormNow, isFormFocusedRef }) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const hashParams = new URLSearchParams(location.hash.substring(1));
  const getParam = (key) => searchParams.get(key) || hashParams.get(key);
  const utm_id = getParam("utm_id");
  const utm_source = getParam("utm_source");
  const utm_medium = getParam("utm_medium");
  const utm_content = getParam("utm_content");
  const utm_campaign = getParam("utm_campaign");
  const utm_city = getParam("utm_city");
  const utm_term = getParam("utm_term");
  const device = getParam("device");

  const paths = location?.pathname.split("/").filter((path) => path !== "");
  const { addToast } = useToasts();
  const recaptchaRef = useRef();
  const { ConfigData, showEnquirePrdouctName } = useSelector(
    (state) => state.homePageSlice
  );
  let resetFunc;
  const [contactUs, { data: contactUsData, loading: contactUsLoading, error }] =
    useMutation(CONTACT_US);

  function onChange(setFieldValue, e) {
    if (e !== null) {
      setFieldValue("captcha", e);
    } else {
      setFieldValue("captcha", "");
    }
  }

  return (
    <>
      <div className={classNames("offcanvas-header", classes.header)}>
        <div className={classes.heading}>
          <h2 id="offcanvasLeftLabel" className={classes.feedbackHeading}>
            Enquire Now
          </h2>
        </div>
        <button
          type="button"
          className={` btn-close text-reset ${classes.cross_button}`}
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          style={{
            background: `url(${closeIcon}) `,
            height: "5px",
            width: "5px ",
          }}
          onClick={() => {
            resetFunc();
            setShowEnquireFormNow(false);
            if (recaptchaRef.current) {
              recaptchaRef.current.reset();
            }
          }}
        ></button>
      </div>
      <div className={`offcanvas-body ${classes["sidebar-contact"]}`}>
        <div className={classes.scroll}>
          <Formik
            initialValues={{
              name: "",
              surname: "",
              email: "",
              subject: "",
              message: "",
              phone: "",
              pincode: "",
              formType: "Enquire Now",
              captcha: "",
              terms: true,
            }}
            validationSchema={feedBackSchema}
            onSubmit={async (values, { resetForm, isValid }) => {
              try {
                const parser = new UAParser();
                const result = parser.getResult();
                const isUAParserMobile =
                  result.device.type === "mobile" ||
                  result.device.type === "tablet";
                const isIPadOS =
                  navigator.platform === "MacIntel" &&
                  navigator.maxTouchPoints > 1;
                const isTouchDevice =
                  window.matchMedia("(pointer: coarse)").matches &&
                  window.matchMedia("(hover: none)").matches;
                const isMobileDevice =
                  isUAParserMobile || isIPadOS || isTouchDevice;
                const response = await contactUs({
                  variables: {
                    fullname: values.name,
                    sirname: "",
                    email: values.email,
                    subject: "",
                    message: values.message,
                    phone: values.phone,
                    pincode: values.pincode,
                    type: values.formType,
                    product_name: !paths.length
                      ? "Home Page"
                      : showEnquirePrdouctName
                      ? showEnquirePrdouctName
                      : "",

                    g_captcha_response: values.captcha,
                    utm_id: utm_id ? utm_id : "",
                    utm_source: utm_source ? utm_source : "",
                    utm_medium: utm_medium ? utm_medium : "",
                    utm_content: utm_content ? utm_content : "",
                    utm_campaign: utm_campaign ? utm_campaign : "",
                    utm_city: utm_city ? utm_city : "",
                    utm_term: utm_term ? utm_term : "",
                    device: device
                      ? device
                      : isMobileDevice
                      ? "Mobile"
                      : "Desktop",
                  },
                });
                if (
                  !contactUsLoading &&
                  response?.data?.contactusFormSubmit?.success_message
                ) {
                  console.log("response", response);
                  addToast(response.data.contactusFormSubmit.success_message, {
                    appearance: "success",
                    autoDismiss: true,
                    style: {
                      backgroundColor: "#027B51",
                      color: "#fff",
                    },
                  });
                  resetForm();
                  setShowEnquireFormNow(false);
                  if (recaptchaRef?.current) {
                    recaptchaRef?.current.reset();
                  }
                  const myOffcanvas = document.getElementById("offcanvasLeft");
                  const bsOffcanvas = new Offcanvas(myOffcanvas);
                  bsOffcanvas.hide();
                }
              } catch (err) {
                addToast(err.message, {
                  appearance: "error",
                  autoDismiss: true,
                  style: {
                    backgroundColor: "#DB1F00",
                    color: "#fff",
                  },
                });
              }
            }}
          >
            {({
              errors,
              touched,
              resetForm,
              isValid,
              isSubmitting,
              setFieldValue,
              values,
            }) => {
              resetFunc = resetForm;
              const optionsToBeFilled = Object.keys(values).filter(
                (item) =>
                  item !== "subject" &&
                  item !== "surname" &&
                  item !== "formType"
              );
              return (
                <Form>
                  <div className="row">
                    <div
                      className="form-group col-md-12"
                      style={{ marginBottom: "12px" }}
                    >
                      <Field
                        type="text"
                        name="name"
                        id="name"
                        className={classNames(
                          "form-control",
                          classes.textField
                        )}
                        placeholder="Name*"
                        onFocus={() => (isFormFocusedRef.current = true)}
                      />
                      {errors.name && touched.name ? (
                        <span
                          className="error"
                          id="username_err"
                          style={{ color: "#FF0000", fontSize: "12px" }}
                        >
                          {errors.name}
                        </span>
                      ) : null}
                    </div>
                    <div
                      className="form-group col-md-12"
                      style={{ marginBottom: "12px" }}
                    >
                      <Field
                        type="email"
                        name="email"
                        id="email"
                        className={classNames(
                          "form-control",
                          classes.textField
                        )}
                        placeholder="Email*"
                        onFocus={() => (isFormFocusedRef.current = true)}
                      />

                      {errors.email && touched.email ? (
                        <span
                          className="error"
                          id="username_err"
                          style={{ color: "#FF0000", fontSize: "12px" }}
                        >
                          {errors.email}
                        </span>
                      ) : null}
                    </div>
                    <div
                      className="form-group col-md-12"
                      style={{ marginBottom: "12px" }}
                    >
                      <Field
                        type="text"
                        name="phone"
                        id="phone"
                        className={classNames(
                          "form-control",
                          classes.textField
                        )}
                        placeholder="Mobile*"
                        onFocus={() => (isFormFocusedRef.current = true)}
                      />
                      {errors.phone && touched.phone ? (
                        <span
                          className="error"
                          id="username_err"
                          style={{ color: "#FF0000", fontSize: "12px" }}
                        >
                          {errors.phone}
                        </span>
                      ) : null}
                    </div>
                    <div
                      className="form-group col-md-12"
                      style={{ marginBottom: "12px" }}
                    >
                      <Field
                        type="text"
                        name="pincode"
                        id="pincode"
                        className={classNames(
                          "form-control",
                          classes.textField
                        )}
                        placeholder="Pincode*"
                        onFocus={() => (isFormFocusedRef.current = true)}
                      />
                      {errors.pincode && touched.pincode ? (
                        <span
                          className="error"
                          style={{ color: "#FF0000", fontSize: "12px" }}
                        >
                          {errors.pincode}
                        </span>
                      ) : null}
                    </div>

                    <div
                      className="form-group col-md-12"
                      style={{ marginBottom: "12px" }}
                    >
                      <Field
                        type="text"
                        as="textarea"
                        name="message"
                        id="message"
                        className={"form-control"}
                        placeholder="Message"
                        style={{ borderRadius: "10px", padding: "10px" }}
                        rows="2"
                        onFocus={() => (isFormFocusedRef.current = true)}
                      />
                      <span className="error" id="message_err">
                        {" "}
                      </span>
                      {errors.message && touched.message ? (
                        <span
                          className="error"
                          id="username_err"
                          style={{ color: "#FF0000", fontSize: "12px" }}
                        >
                          {errors.message}
                        </span>
                      ) : null}
                    </div>

                    {ConfigData?.recaptcha_site_key && (
                      <div className="col-12">
                        <ReCAPTCHA
                          sitekey={ConfigData?.recaptcha_site_key}
                          onChange={(e) => onChange(setFieldValue, e)}
                          ref={recaptchaRef}
                        />
                        {errors.captcha && touched.captcha ? (
                          <p style={{ color: "#FF0000", fontSize: "12px" }}>
                            {errors.captcha}
                          </p>
                        ) : null}
                      </div>
                    )}

                    <div className="col-12">
                      <div className={classes.checkWrapper}>
                        <Field type="checkbox" name="terms" />
                        <label htmlFor="terms" className="form-label">
                          I hereby agree and authorize Hettich India Pvt. Ltd
                          and all its subsidiaries to call / email / SMS /
                          WhatsApp me with product / service/ offer /other
                          communications
                        </label>
                      </div>
                      {errors.terms && touched.terms ? (
                        <p style={{ color: "#FF0000", fontSize: "12px" }}>
                          {errors.terms}
                        </p>
                      ) : null}
                    </div>

                    <div className="col-md-12">
                      <button
                        className={classes["manual-btn"]}
                        type="submit"
                        data-bs-dismiss={"offcanvas"}
                        aria-label={"Close"}
                        disabled={
                          Object.keys(errors).length > 0 ||
                          isSubmitting ||
                          Object.keys(values)
                            .filter(
                              (item) =>
                                ![
                                  "subject",
                                  "surname",
                                  "formType",
                                  "message",
                                ].includes(item)
                            )
                            .some((item) => !values[item])
                        }
                      >
                        {isSubmitting ? (
                          <span
                            class="spinner-border spinner-border-sm text-light"
                            role="status"
                          >
                            <span class="visually-hidden">Loading...</span>
                          </span>
                        ) : (
                          <>
                            <i
                              className="fa fa-paper-plane"
                              aria-hidden="true"
                            ></i>{" "}
                            SUBMIT
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
    </>
  );
};

export default EnquiryForm;
